import { fromJS } from 'immutable';
import { jsonToFormData } from '../../helpers/HelperFunctions';
import billSchema from '../schemas/billSchema';

const SENDBILL = 'twineApp/messages/SENDBILL';
const SENDBILL_SUCCESS = 'twineApp/messages/SENDBILL_SUCCESS';
const SENDBILL_FAIL = 'twineApp/messages/SENDBILL_FAIL';
const GETBILLTOTALS = 'twineApp/messages/GETBILLTOTALS';
const GETBILLTOTALS_SUCCESS = 'twineApp/messages/GETBILLTOTALS_SUCCESS';
const GETBILLTOTALS_FAILURE = 'twineApp/messages/GETBILLTOTALS_FAILURE';

const initialState = {
  savingBill: false,
  loadingBills: false,
  loadedBills: false,
  billTotals: null,
  bills: [],
};

export default function reducer(state = initialState, action = {}) {
  const imState = fromJS(state);

  switch (action.type) {
    case SENDBILL:
      return imState
        .mergeDeep({
          savingBill: true,
        })
        .toJS();

    case SENDBILL_SUCCESS:
      return imState
        .mergeDeep({
          savingBill: false,
        })
        .toJS();

    case SENDBILL_FAIL:
      return imState
        .mergeDeep({
          savingBill: false,
        })
        .toJS();

    case GETBILLTOTALS:
      return imState
        .mergeDeep({
          loadingBills: true,
          loadedBills: false,
          billTotals: null,
          bills: [],
        })
        .toJS();

    case GETBILLTOTALS_SUCCESS:
      return imState
        .mergeDeep({
          loadingBills: false,
          loadedBills: true,
          billTotals: action.result.totals,
          bills: action.entities.bill,
        })
        .toJS();

    case GETBILLTOTALS_FAILURE:
      return imState
        .mergeDeep({
          loadingBills: false,
          loadedBills: false,
          billTotals: null,
          bills: [],
        })
        .toJS();

    default:
      return imState.toJS();
  }
}

export function sendBill(pitchId, statementOfWork, amount, invoice) {
  const data = {
    pitch_id: pitchId,
    statement_of_work: statementOfWork,
    amount,
  };

  if (Object.keys(invoice).length > 0) {
    for (const [key, value] of Object.entries(invoice)) {
      if (!value || value === 'null' || value === 'select' || value === '+') {
        delete invoice[key];
      }
    }

    data.invoice = invoice;
  }

  return {
    types: [SENDBILL, SENDBILL_SUCCESS, SENDBILL_FAIL],
    promise: (client) =>
      client.post('/bills', {
        data: jsonToFormData(data),
      }),
    schema: billSchema,
  };
}

export function loadBills(pitchId, billIds) {
  return {
    promise: (client) => {
      const result = client.get(
        `/bills/${pitchId}?include=fees&ids=${billIds}`
      );
      return Promise.resolve(result);
    },
    types: [GETBILLTOTALS, GETBILLTOTALS_SUCCESS, GETBILLTOTALS_FAILURE],
  };
}

export function calculatePaymentForBills(pitchId, billIds) {
  return {
    promise: (client) => {
      const results = client.get(
        `/bills/${pitchId}?ids=${billIds}&include=fees`
      );
      return Promise.resolve(results);
    },
    schema: { bills: [billSchema] },
    types: [GETBILLTOTALS, GETBILLTOTALS_SUCCESS, GETBILLTOTALS_FAILURE],
  };
}

export function calculatePaymentForAmount(pitchId, amount) {
  return {
    promise: (client) => {
      const results = client.get(
        `/bills/${pitchId}/calculate-fee?amount=${amount}`
      );
      return Promise.resolve(results);
    },
    schema: { bills: [billSchema] },
    types: [GETBILLTOTALS, GETBILLTOTALS_SUCCESS, GETBILLTOTALS_FAILURE],
  };
}
